import { MIN_PTCODE } from '../../../../utils/formValidation/commonConstants';
import {
    getCharMinMessage,
    getReqMessage,
    getSelectMessage,
    getStartWithMessage
} from '../../../../utils/formValidation/errorMessageFunctions';

import { validateNotes } from './commonFunctions';

export const validate = (newEntry) => {
    let newErrors = {};

    if (!newEntry.requestTypeId) {
        newErrors = {
            ...newErrors,
            requestTypeId: { error: true, message: getSelectMessage('request type') }
        };
    }

    if (!newEntry.priorityId) {
        newErrors = {
            ...newErrors,
            priorityId: { error: true, message: getSelectMessage('priority') }
        };
    }

    if (!newEntry.ptCode) {
        newErrors = {
            ...newErrors,
            ptCode: { error: true, message: getReqMessage('PT code') }
        };
    } else if (!newEntry.ptCode.startsWith('PT')) {
        newErrors = {
            ...newErrors,
            ptCode: { error: true, message: getStartWithMessage('PT code', 'PT') }
        };
    } else if (newEntry.ptCode.length < MIN_PTCODE) {
        newErrors = {
            ...newErrors,
            ptCode: { error: true, message: getCharMinMessage('PT code', MIN_PTCODE) }
        };
    }

    newErrors = validateNotes(newEntry.notes, newErrors);

    return newErrors;
};
